"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVaccinationRecordDoseOnlyDto = instanceOfVaccinationRecordDoseOnlyDto;
exports.VaccinationRecordDoseOnlyDtoFromJSON = VaccinationRecordDoseOnlyDtoFromJSON;
exports.VaccinationRecordDoseOnlyDtoFromJSONTyped = VaccinationRecordDoseOnlyDtoFromJSONTyped;
exports.VaccinationRecordDoseOnlyDtoToJSON = VaccinationRecordDoseOnlyDtoToJSON;
exports.VaccinationRecordDoseOnlyDtoToJSONTyped = VaccinationRecordDoseOnlyDtoToJSONTyped;
const VaccinationDoseOnlyDateDto_1 = require("./VaccinationDoseOnlyDateDto");
/**
 * Check if a given object implements the VaccinationRecordDoseOnlyDto interface.
 */
function instanceOfVaccinationRecordDoseOnlyDto(value) {
    if (!('vaccinations' in value) || value['vaccinations'] === undefined)
        return false;
    return true;
}
function VaccinationRecordDoseOnlyDtoFromJSON(json) {
    return VaccinationRecordDoseOnlyDtoFromJSONTyped(json, false);
}
function VaccinationRecordDoseOnlyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'vaccinations': (json['vaccinations'].map(VaccinationDoseOnlyDateDto_1.VaccinationDoseOnlyDateDtoFromJSON)),
    };
}
function VaccinationRecordDoseOnlyDtoToJSON(json) {
    return VaccinationRecordDoseOnlyDtoToJSONTyped(json, false);
}
function VaccinationRecordDoseOnlyDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'vaccinations': (value['vaccinations'].map(VaccinationDoseOnlyDateDto_1.VaccinationDoseOnlyDateDtoToJSON)),
    };
}
//# sourceMappingURL=VaccinationRecordDoseOnlyDto.js.map